// Submission confirmation for the product hub's checklist card. The button
// submits its own form (POST submit_review) once the creator confirms.
$(document).on("turbolinks:load", function () {
  var $button = $(".js-submit-review-btn")
  if (!$button.length) return

  var trusted = "true" == String($button.data("trusted"))

  $button.on("click", function (e) {
    e.preventDefault()

    swal({
      title: trusted ? "Product Publish" : "Product Review Information",
      text: review_text(),
      icon: "info",
      customClass: {
        popup: "cy-product-submit-btn-wrapper",
      },
      buttons: {
        cancel: {
          text: "Not Yet",
          value: false,
          visible: true,
          className: "",
          closeModal: true,
        },
        confirm: {
          text: trusted ? "Schedule & Publish" : "Submit for Review",
          value: true,
          visible: true,
          className: "cy-popup-submit-for-review-btn",
          closeModal: true,
        },
      },
    }).then((isConfirm) => {
      if (isConfirm) {
        $button.closest("form")[0].submit()
      }
    })
  })

  function review_text() {
    if (trusted) {
      return "As a Trusted Creator your product does not need to be reviewed. Upon confirmation, your product will be scheduled and published."
    } else {
      return "Product reviews typically take between 3-5 days, depending on the current queue. After submitting for review, you will no longer be able to edit your product until it's published or sent back for changes. Please take this time to ensure your product is ready for public display!"
    }
  }
})
